<div class="page-innder-body portlet light mx-1 my-3 ">
  <div class="portlet-body p-0">
    <div class="row g-0 mt-3">
      <!-- First Card -->
      <div class="col-md-3">
        <div class="card border-primary rounded shadow">
          <div class="card-body">
            <span>
              <i class="fa fa-briefcase text-primary "></i> {{ 'adminDashboard.totalArtistsProducts' | transloco }}
            </span>
            @if (adminDashboardDataLoaded) {
              <div class="fw-bold">{{ AdminDashboardData.TotalArtistProducts }}</div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between w-100 my-3">
      <div class="card px-3 py-2 w-50 me-2 shadow">
        <h5><i class="fa fa-users text-primary me-2"></i>{{ 'adminDashboard.artists' | transloco }}</h5>
        <ul class="list-unstyled">
          <li>
            <div class="d-flex justify-content-between">{{ 'adminDashboard.totalArtists' | transloco }} @if (adminDashboardDataLoaded) {
              <span class="text-primary fw-bold">{{ AdminDashboardData.ArtistAccounts.TotalArtist }}</span>
            }</div>
          </li>
          <li>
            <div class="d-flex justify-content-between">{{ 'adminDashboard.totalFreeArtistAccounts' | transloco }}  @if (adminDashboardDataLoaded) {
              <span class="fw-bold">{{ AdminDashboardData.ArtistAccounts.TotalFreeArtist }}</span>
            }</div>
          </li>
          <li>
            <div class="d-flex justify-content-between">{{ 'adminDashboard.totalProArtistAccounts' | transloco }} @if (adminDashboardDataLoaded) {
              <span class="text-success fw-bold">{{ AdminDashboardData.ArtistAccounts.TotalProArtist }}</span>
            }</div>
          </li>
        </ul>
      </div>
      <div class="card px-3 py-2 w-50 shadow">
        <h5><i class="fa fa-file-image-o text-primary me-2"></i>{{ 'adminDashboard.galleries' | transloco }}</h5>
        <ul class="list-unstyled">
          <li>
            <div class="d-flex justify-content-between">{{ 'adminDashboard.totalGalleries' | transloco }} @if (adminDashboardDataLoaded) {
              <span class="text-primary fw-bold">{{ AdminDashboardData.GalleryAccounts.TotalGallery }}</span>
            }</div>
          </li>
          <li>
            <div class="d-flex justify-content-between">{{ 'adminDashboard.totalFreeGalleryAccounts' | transloco }}  @if (adminDashboardDataLoaded) {
              <span class="fw-bold">{{ AdminDashboardData.GalleryAccounts.TotalFreeGallery }}</span>
            }</div>
          </li>
          <li>
            <div class="d-flex justify-content-between">{{ 'adminDashboard.totalProGalleryAccounts' | transloco }} @if (adminDashboardDataLoaded) {
              <span class="text-success fw-bold">{{ AdminDashboardData.GalleryAccounts.TotalProGallery }}</span>
            }</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="border shadow mt-2">
    @if (adminDashboardDataLoaded) {
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="selectedTabIndex">
        @for (item of AdminDashboardData.StripeInsightsCharts; track item) {
          <p-tabPanel [header]="item.SeriesName">
            <admin-insights-chart [insightsSeriesData]="item" [selectedTabIndex]="selectedTabIndex"></admin-insights-chart>
          </p-tabPanel>
        }
      </p-tabView>
    }
  </div>
</div>